import { TDeviceType } from '@cian/ui-kit';

import { EOffersFetchingMode } from '../../actions/listingModal';
import { IApplicationState } from '../../types/redux';
import { selectIsDesktopListingAvailable, selectIsDesktopListingVisible } from '../desktopListing';
import { selectIsModalOpen, selectOffersFetchingMode } from '../listingModal';

export function selectShouldLoadListingForHybridSearch(state: IApplicationState, deviceType: TDeviceType): boolean {
  if (deviceType === 'desktop') {
    return selectIsDesktopListingAvailable(state) && selectIsDesktopListingVisible(state);
  }

  return selectIsModalOpen(state) && selectOffersFetchingMode(state) === EOffersFetchingMode.ALL;
}
